import axios from "axios";
import instance from "../../utils/axios";
import { LOGOUT, MODIFY_NAME, SNACK_OPEN } from "./actions.types";
import { getToken, validateRefId } from "../../utils/helperFn";
import { getApiUrl } from "../../utils/apiUrls";

export const modifyName = (data) => ({
    type: MODIFY_NAME,
    payload: data,
});

export const refreshToken = async () => {
    const token = getToken();

    if(!!token) {
        const res = await axios.get(getApiUrl('refreshToken'), {
            headers: {
                "Authorization" : `Bearer ${token}`,
            }
        });

        return res.data;
    }
} 

export const setPassword = (data) => async (dispatch, getState) => {
    try {
        const setPasswordData = await axios.post(getApiUrl('resetPassword'), data);

        if(setPasswordData.data === 'success') {
            dispatch({
                type: SNACK_OPEN,
                payload: {
                    msg: 'Password reset successful. Use the new password next time you log in',
                    type: 'success'
                }
            })
        }

        // dispatch({
        //     type: SIGN_UP,
        //     payload: data,
        // })
    } catch (err) {
        dispatch({
            type: SNACK_OPEN,
            payload: {
                msg: err.message,
                type: 'error'
            }
        })

        if(err.response) {
            // console.log(err.response.data);
            // console.log(err.response.status);
            // console.log(err.response.headers);
        } else if (err.request) {
            // The request was made but no response was received
            // console.log(err.request);
        } else {
            // Something happened in setting up the request that triggered an err
            // console.log('err', err.message);
        }
      
    }
}

export const logout = (lang, rawRefId) => async (dispatch, getState) => {
    try {
        const token = getToken();
        const refId = validateRefId(rawRefId);
        const savedReturnUrl = getState()?.user?.returnUrl;
        //window.location.replace("login");

        //cookies.remove('token');

        // localStorage.removeItem('token', null);

        const res = await instance.get(getApiUrl('logoutCandidate'),{headers: {
            "Authorization" : `Bearer ${token}`,
        }});      

        localStorage.clear();
        
        window.location.href = savedReturnUrl ? savedReturnUrl : `/${!!lang ? `?lang=${lang}` : ''}${refId ? `${lang ? "&" : "?"}refId=${refId}` : ''}`;

        dispatch({
            type: LOGOUT,
        })
    } catch (err) {
        const refId = validateRefId(rawRefId);
        const savedReturnUrl = getState()?.appSettings?.returnUrl;
        localStorage.clear();
        window.location.href = savedReturnUrl ? savedReturnUrl : `/${!!lang ? `?lang=${lang}` : ''}${refId ? `${lang ? "&" : "?"}refId=${refId}` : ''}`;
 
        dispatch({
            type: LOGOUT,
        })
        // console.log('Logout error:', err);
        dispatch({
            type: SNACK_OPEN,
            payload: {
                msg: err.message,
                type: 'error'
            }
        })
    }
}